module.exports = {
  siteTitle: 'Lista rzeczy', // Site title.
  siteTitleAlt: 'lista przedmiotów', // Alternative site title for SEO.
  siteLogo: '/icons/icon-512x512.png', // Logo used for SEO and manifest.
  siteUrl: 'https://lista-rzeczy.pait.pl', // Domain of your website without pathPrefix.
  pathPrefix: '', // Prefixes all links. For cases when deployed to example.github.io/gatsby-starter-business/.
  siteDescription: 'Wybierasz się gdzieś? Sprawdź co ze sobą zabrać na narty, na plażę, na basen czy na siłownię. Dbamy abyś niczego nie zapomniał.', // Website description used for RSS feeds/meta description tag.
  siteRss: '/rss.xml',
  siteFBAppID: '', // FB Application ID for using app insights
  googleTagManagerID: '', // GTM tracking ID.
  disqusShortname: 'lista-rzeczy.pait.pl', // Disqus shortname.
  userName: 'Tomasz Paszek',
  userTwitter: 'vaibhaved',
  userLocation: 'Katowice, Poland',
  userDescription: 'opis użytkownika',
  copyright: 'Copyright © lista-rzeczy.pait.pl 2018-2019. All Rights Reserved.', // Copyright string for the footer of the website and RSS feed.
  themeColor: '#00d1b2', // Used for setting manifest and progress theme colors.
  backgroundColor: '#ffffff', // Used for setting manifest background color.
}
